import React from 'react';
import { Table, Icon } from 'semantic-ui-react'
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types'
import { EVENT_SHOW_LINK} from '../helpers/AppConsts'

const UpcommingGameItem = ({bridgeEvent}) => {

  const linkAddress = () => {
    const {event_id, event_date} = bridgeEvent;
    return `${EVENT_SHOW_LINK}/${event_id}/${event_date}`
  }

  const linkText = () => {
    const {event_day, event_month, event_year} = bridgeEvent;
    return `${event_day}-${event_month}-${event_year}`;
  }

  // const imgSrc = () => {
  //   const {event_img} = bridgeEvent;
  //   return (event_img !== AVAILABLE_AFTER_COMPLETION) ? event_img : BRIDGEMATE_BLACK_LOGO_PATH; 
  // }

  return (
    
    // <Table.Body>
      <Table.Row>
        <Table.Cell collapsing>
          <Icon name='calendar outline' /> <Link style={{color:'#008000'}} to={ linkAddress() }>
            
            { linkText() }
          </Link>
        </Table.Cell>
        {/*<Table.Cell>{bridgeEvent.event_name}</Table.Cell>*/}
        <Table.Cell collapsing textAlign='right'>
        {bridgeEvent.event_club}
        </Table.Cell>
        <Table.Cell>{bridgeEvent.event_location}</Table.Cell>
        <Table.Cell>{bridgeEvent.event_year}</Table.Cell>
      </Table.Row>
      //  </Table.Body>

    

  // </Table>
    
    // <Item>
    //   {/* <Item.Image src={ imgSrc() } wrapped ui={false} /> */}
    //   <Item.Content>
    //     <Item.Header>
    //       <Link style={{color:'#008000'}} to={ linkAddress() }>
    //         { linkText() }
    //       </Link>
    //     </Item.Header>
    //     <Item.Description><h3>{bridgeEvent.event_name} </h3> </Item.Description>
    //     <Item.Meta>{bridgeEvent.event_club}</Item.Meta>
    //   </Item.Content>
    // </Item>
  );


};

UpcommingGameItem.propTypes = {
  bridgeEvent: PropTypes.shape({
        event_img: PropTypes.string.isRequired,
        event_name: PropTypes.string.isRequired,
        event_id: PropTypes.string.isRequired,
        event_date: PropTypes.string.isRequired,
        event_month: PropTypes.string.isRequired,
        event_day: PropTypes.string.isRequired,
        event_year: PropTypes.string.isRequired,
        event_club: PropTypes.string.isRequired
      }
  ).isRequired
}

export default UpcommingGameItem;
